import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { FloorplanMonitoringItemDetailsModalComponent } from "@components/floorplan-monitoring-item-details-modal/floorplan-monitoring-item-details-modal.component";
import { StandardImageComponent } from "@components/standard-image/standard-image.component";
import { StepSelectionType } from "@domain/product/monitoring/family/family-step";
import { MonitoringCategory } from "@domain/product/monitoring/monitoring-product.service";
import { AreaHeaderComponent } from "@odx/angular/components/area-header";
import { ContentBoxComponent } from "@odx/angular/components/content-box";
import { ModalService, ModalSize } from "@odx/angular/components/modal";
import { createMonitoringGroupedSourceItem } from "@project/monitoring/grouped-parts/monitoring-grouped-parts-source-item.factory";
import { isGroupedOption } from "@project/monitoring/grouped-parts/monitoring-grouped-parts.helper";
import { MonitoringGroupedPartSourceItem } from "@project/monitoring/grouped-parts/monitoring-grouped-parts.types";
import { OptionDisplay } from "@project/monitoring/option-display.service";

@Component({
  selector: "app-monitoring-option-card",
  imports: [AreaHeaderComponent, ContentBoxComponent, UiKitModule, StandardImageComponent],
  templateUrl: "./monitoring-option-card.component.html",
  styleUrl: "./monitoring-option-card.component.scss",
})
export class MonitoringOptionCardComponent {
  private modalService = inject(ModalService);

  @Input() option!: OptionDisplay;
  @Input() selectionMode!: string;
  @Input() category?: MonitoringCategory;
  @Input() categoryLabel?: string;
  @Input() set isSelected(selected: boolean) {
    this.selected = selected;
  }

  @Output() select$ = new EventEmitter<boolean>();

  protected selected = false;

  protected readonly StepSelectionType = StepSelectionType;
  protected readonly groupModalSuffix = $localize`:@@monitoring.groupedParts.modal.components:Components`;

  protected get isGroup(): boolean {
    return isGroupedOption(this.option?.option);
  }

  protected showGroupDetails() {
    if (!this.isGroup) return;

    const resolvedCategory = this.category ?? MonitoringCategory.PATIENT_MONITORS;
    const title = this.option?.displayName ? `${this.option.displayName} - ${this.groupModalSuffix}` : this.groupModalSuffix;
    const items: MonitoringGroupedPartSourceItem[] = [
      createMonitoringGroupedSourceItem({ option: this.option.option, quantity: 1 }, this.categoryLabel ?? ""),
    ];

    this.modalService.open(FloorplanMonitoringItemDetailsModalComponent, {
      id: "monitoring-item-details-modal",
      size: ModalSize.LARGE,
      data: { items, category: resolvedCategory, title, showCategory: false, hideUnavailable: true },
    });
  }
}
